import i18n from '../i18n';
import { corporateWalletFlag } from '../config/build';
import { LanguageCode, PREFERRED_LANGUAGE_KEY, normaliseLanguage } from './localeTag';

// Re-export the pure locale helpers so existing consumers keep importing them
// from this module. The normalisation logic and storage key live in
// ./localeTag (no i18n dependency) to avoid being duplicated in src/i18n.ts.
export type { LanguageCode } from './localeTag';
export { PREFERRED_LANGUAGE_KEY, normaliseLanguage, detectInitialLanguage } from './localeTag';

// Supported UI dialects. `en` is the canonical British base; `en-US` is a thin
// American override that falls back to `en` for any string it does not define.
// Corporate builds ship a single `en` bundle (see i18n.ts), so en-US is never
// offered there to avoid persisting a dialect that isn't bundled.
export const SUPPORTED_LANGUAGES = (
	corporateWalletFlag
		? [{ code: 'en', label: 'English (UK)' }]
		: [
				{ code: 'en', label: 'English (UK)' },
				{ code: 'en-US', label: 'English (US)' }
		  ]
) as readonly { code: LanguageCode; label: string }[];

/**
 * Persist the chosen dialect and apply it immediately to the running app.
 */
export const setPreferredLanguage = (code: string): void => {
	const normalised = normaliseLanguage(code);
	try {
		localStorage.setItem(PREFERRED_LANGUAGE_KEY, normalised);
	} catch {
		// Ignore storage failures — the in-memory change below still applies.
	}
	if (i18n.language !== normalised) {
		i18n.changeLanguage(normalised);
	}
};
